import type { GetSubscriptionByOrder200Subscription } from './getSubscriptionByOrder200Subscription';

/**
 * 구독 정보 응답
 */
export type GetSubscriptionByOrder200 = {
  /** 결제 금액 */
  amount?: number;
  /**
   * 오류 메시지 (실패 시)
   * @nullable
   */
  errorMessage?: string | null;
  /** 주문 ID */
  orderId?: string;
  /** 상품명 */
  productName?: string;
  /** 상품 플랜 코드 */
  productPlanCode?: string;
  /**
   * 구독 정보
   * @nullable
   */
  subscription?: GetSubscriptionByOrder200Subscription;
  /** 성공 여부 */
  success: boolean;
  /** 사용자 ID */
  userId?: string;
};
